import httpCommon from "@/http-common";

class DeviceRecognitionService {

    findAllDevices(idSchool, active, pageNumber, maxPageItem) {
        return httpCommon.get("/webhook/recognition", {params: {idSchool, active, pageNumber, maxPageItem}});
    }
    createDeviceRecognition(data){
        return httpCommon.post(`/webhook/recognition-create`, data)
    }
    getDetailOneDevices(id) {
        return httpCommon.get(`/webhook/recognition/${id}`);
    }

    registerWebhook(id) {
        return httpCommon.get(`/webhook/register-webhook/${id}`);
    }

    registerWebhookManyDevice(listId) {
        return httpCommon.post(`/webhook/register-webhook/many`, listId);
    }

    deleteWebhook(id) {
        return httpCommon.delete(`/webhook/delete-webhook`,{params:{id}});
    }

    checkConnectionDevice(idList){
        return httpCommon.post(`/webhook/check-device`,idList);
    }

    checkDevicesMacAddress(id){
        return httpCommon.get(`/webhook/device/${id}/info`,);
    }

    updateDeviceRecognition(data){
        return httpCommon.put(`/webhook/recognition-update`, data)
    }

    deleteDeviceRecognition(id){
        return httpCommon.delete(`/webhook/recognition/${id}`);
    }

    createConfigDevice(idSchool){
        return httpCommon.get(`/webhook/create/config/${idSchool}`);
    }
}
export default new DeviceRecognitionService();